<script>
	export let iconClass = '';
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class={iconClass}>
	<g clip-path="url(#clip0_360_509)">
		<path d="M15 10.5H16C16.2652 10.5 16.5196 10.6054 16.7071 10.7929C16.8946 10.9804 17 11.2348 17 11.5V17L15 15H12C11.7348 15 11.4804 14.8946 11.2929 14.7071C11.1054 14.5196 11 14.2652 11 14V13.5M13 10.5C13 10.7652 12.8946 11.0196 12.7071 11.2071C12.5196 11.3946 12.2652 11.5 12 11.5H9L7 13.5V8C7 7.73478 7.10536 7.48043 7.29289 7.29289C7.48043 7.10536 7.73478 7 8 7H12C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8V10.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<defs>
		<clipPath id="clip0_360_509">
			<rect width="12" height="12" fill="white" transform="translate(6 6)"/>
		</clipPath>
	</defs>
</svg>
